import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";

export default function CloseTicketModal({ show, handleClose }) {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Close Ticket</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="g-3">

          {/* Ticket ID */}
          <Col md={6}>
            <div className="modal-card danger">
              <label>Ticket ID</label>
              <input type="text" placeholder="Enter Ticket ID" />
            </div>
          </Col>

          {/* Reason */}
          <Col md={6}>
            <div className="modal-card warning">
              <label>Reason</label>
              <select>
                <option>Resolved</option>
                <option>Duplicate</option>
                <option>Invalid</option>
              </select>
            </div>
          </Col>

          {/* Notes */}
          <Col md={12}>
            <div className="modal-card">
              <label>Closing Notes</label>
              <textarea rows="3" placeholder="Add notes..." />
            </div>
          </Col>

        </Row>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={handleClose}>
          Cancel
        </Button>
        <Button className="danger-btn">
          Close Ticket
        </Button>
      </Modal.Footer>
      <style>
          {
               `
               /* Create button */
.create-btn {
  background: linear-gradient(90deg, #ff7a18, #ff4d2d);
  border: none;
  color: #fff;
  padding: 8px 14px;
  border-radius: 6px;
}

/* Close button */
.close-btn {
  background: #0f3d4c;
  border: none;
  color: #fff;
  padding: 8px 14px;
  border-radius: 6px;
}

/* Modal cards */
.modal-card {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px;
  display: flex;
  flex-direction: column;
}

/* Variants */
.modal-card.danger {
  background: #fef2f2;
  border: 1px solid #fecaca;
}

.modal-card.warning {
  background: #fff7ed;
  border: 1px solid #fed7aa;
}

/* Labels */
.modal-card label {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 6px;
}

/* Inputs */
.modal-card input,
.modal-card select,
.modal-card textarea {
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
}

/* Submit buttons */
.submit-btn {
  background: #0ea5e9;
  border: none;
  color: white;
  border-radius: 6px;
}

.danger-btn {
  background: #ef4444;
  border: none;
  color: white;
  border-radius: 6px;
}

/* Mobile spacing */
@media (max-width: 576px) {
  .modal-card {
    margin-top: 10px;
  }
}`
          }
      </style>
    </Modal>
  );
}